import React from "react";
import styled from "styled-components";
import { CheckCircle, CloseRounded, HourglassBottomRounded, DeleteOutlineOutlined as DeleteOutline, AdminPanelSettings, Eject, Block, HourglassEmpty, History, HelpOutlineOutlined as HelpOutline, SentimentDissatisfied } from '@mui/icons-material';

// Fluent UI messaging color mapping (Fabric/Fluent palette approximations)
// success: #107C10, warning: #F2C811, severeWarning: #D83B01, error: #A4262C, info: #0078D4, blocked/danger: #D13438, neutral: #605E5C
const fluentMessaging = {
  success: { bg: '#dff6dd', fg: '#107c10' },
  warning: { bg: '#fff4ce', fg: '#797673' },
  severeWarning: { bg: '#fed9cc', fg: '#d83b01' },
  error: { bg: '#fde7e9', fg: '#a80000' },
  info: { bg: '#0078D4', fg: '#FFFFFF' },
  blocked: { bg: '#D13438', fg: '#FFFFFF' },
  neutral: { bg: '#605E5C', fg: '#FFFFFF' },
};

export const statusStyles = {
  // Success states
  Active: { color: fluentMessaging.success.bg, textColor: fluentMessaging.success.fg, icon: <CheckCircle style={{ color: 'inherit' }}/> },
  Legacy: { color: fluentMessaging.success.bg, textColor: fluentMessaging.success.fg, icon: <History style={{ color: 'inherit' }}/> },

  // Warning/caution states
  Pending: { color: fluentMessaging.warning.bg, textColor: fluentMessaging.warning.fg, icon: <HourglassBottomRounded style={{ color: 'inherit' }}/> },
  'Wait List': { color: fluentMessaging.warning.bg, textColor: fluentMessaging.warning.fg, icon: <HourglassEmpty style={{ color: 'inherit' }}/> },

  // Severe warning/important
  Discharged: { color: fluentMessaging.severeWarning.bg, textColor: fluentMessaging.severeWarning.fg, icon: <CloseRounded style={{ color: 'inherit' }}/> },
  'Administrative Discharged': { color: fluentMessaging.severeWarning.bg, textColor: fluentMessaging.severeWarning.fg, icon: <AdminPanelSettings style={{ color: 'inherit' }}/> },

  // Errors / blocked
  Denied: { color: fluentMessaging.error.bg, textColor: fluentMessaging.error.fg, icon: <Block style={{ color: 'inherit' }}/> },
  Deceased: { color: fluentMessaging.blocked.bg, textColor: fluentMessaging.blocked.fg, icon: <SentimentDissatisfied style={{ color: 'inherit' }}/> },

  // Informational / neutral
  'E-Referred New': { color: fluentMessaging.info.bg, textColor: fluentMessaging.info.fg, icon: <Eject style={{ color: 'inherit' }}/> },
  Unrecognized: { color: fluentMessaging.info.bg, textColor: fluentMessaging.info.fg, icon: <HelpOutline style={{ color: 'inherit' }}/> },
  Trashed: { color: fluentMessaging.neutral.bg, textColor: fluentMessaging.neutral.fg, icon: <DeleteOutline style={{ color: 'inherit' }}/> },
};

export const AddNoteIcon = styled.img`
  margin-right: 7px;
  fill: white;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #aac8db;
  margin: 0 5px;
  margin-bottom: 15px;
`;

export const ClientsTitleContainer = styled.div`
  font-family: Suez One;
  font-size: 20px;
  font-weight: 400;
  color: #4281AB;
  margin-right: 35px;
`;

export const TableSearchContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TableControlsContainer = styled.div`
  padding: 10px 0px;
  margin: 10px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 20px;
  border: 1px solid rgba(229, 229, 229, 1);
  overflow: hidden;
  padding: 3px 20px;
  background: #fff;
`;

export const SearchInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
`;

export const TableHeadContainer = styled.div`
    color: red;
`;

export const FilterChipList = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const FilterChip = styled.div`
  font-family: Lato;
  font-size: 11px;
  font-weight: 400;
  padding: 5px 14px;
  background: #FBEEC1;
  border-radius: 26px;
  margin-right: 15px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  span{
    color: #4281AB;
    font-family: Open Sans;
    margin-right: 5px;
  }
`;

export const TableRowContainer = styled.div`
  display: flex;
  font-wight: 400;
  font-size: 11px;
  font-weight: 400;
  color: #808080;
  margin-right: 4px;
  margin-top: 8px;
`;

export const ServiceDetails = styled.div`
  paddingTop: 4px;
`;

export const ToolsImg = styled.img`
  margin-right: 4px;
  transform: ${(props) => props.rotate ? 'rotate(180deg);' : 'none'};
`;

export const ToolsImgWhite = styled.img`
  margin-right: 4px;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(101deg) brightness(100%) contrast(105%);
  transform: ${(props) => props.rotate ? 'rotate(180deg);' : 'none'};
`;

export const CrossImg = styled.img`
  margin-left: 5px;
  cursor: pointer;
`;

export const TracksTitle = styled.div`
  margin-right: 5px;
`;


export const TrackWrap = styled.div`
  font-family: Lato;
  font-size: 11px;
  font-weight: 400;
  padding: 5px 14px;
  background: #659DBD;
  border-radius: 26px;
  color: #fff;
  margin: 0 5px;
`;

export const EmptyMessage = styled.div`
  font-family: Suez One;
  font-size: 15px;
  font-weight: 400;
  color: #4281AB;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
`;

export const StatusChip = styled.div`
  font-family: Open Sans;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.2px;
  padding: 3px 9px;
  border-radius: 999px;
  margin: 2px 0;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 4px;  /* To add spacing between icon and text */

  background: ${(props) => statusStyles[props.statusName]?.color || '#f79183'};
  color: ${(props) => statusStyles[props.statusName]?.textColor || '#fff'};

  & svg {
    font-size: 14px;
    display: block;
  }
`;
export const RowOptionContainer = styled.div`
  font-family: Open Sans;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #BD986A;
  margin-top: 5px;
  margin-right: 13px;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 4px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: rgba(189, 152, 106, 0.12);
    color: #8f6e3d;
    text-decoration: underline;
  }
`;

export const NoteContainer = styled.div`
  font-family: Open Sans;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  padding: 7px 9px;
  background: #EFF5F8;
  margin-bottom: 4px;
  color: #000000;
  width: 240px;
  border-radius: 4px;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.14);
  }
`;

export const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NoteName = styled.div`
  font-wight: 600;
`;

export const NoteDate = styled.div`
  font-wight: 400;
  color: #797b7c;
`;

export const NoteText = styled.div`
  font-wight: 400;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  max-width: 100%;
  overflow: hidden;
`;

export const InsuredsType = styled.div`
  font-wight: 400;
  font-size: 11px;
  font-weight: 400;
  color: #808080;
  margin-right: 4px;
`;

export const StatisticsOptions = styled.div`
  display: flex;
`;

// Recent-services pills — mirror the Notes & Alerts card (NoteContainer) so the two
// columns read as one system: pale card, rounded corners, padding, hover-lift.
export const ServiceContainer = styled.div`
  font-family: Open Sans;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  padding: 7px 9px;
  background: #EFF5F8;
  margin-bottom: 4px;
  color: #000000;
  width: 240px;
  border-radius: 4px;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.14);
  }
`;

export const ServiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

export const ServiceButtons = styled.div`
  display: flex;
`;

// Status chip inside the pill — matches the notes card status chip (NotesCardStatus).
export const ServiceStatus = styled.div`
  font-size: 10px;
  background: #FBEEC1;
  padding: 2px 5px;
`;

export const ServiceMaterials = styled.div`
  display: flex;
  align-items: center;
  color: grey;
  cursor: pointer;
`;

export const MaterialsArrow = styled.img`
  margin-left: 2px;
`;

export const ServiceDate = styled.div`
  font-weight: 600;
  color: #797b7c;
`;

export const ServiceName = styled.div`
  font-weight: 400;
`;

export const InsuredsContainer = styled.div`
  display: flex;
`;

export const NotesPanelContainer = styled.div`
  display: ${(props) => props.visibility ? 'block' : 'none'};
  position: fixed;
  top: 0;
  right: 0;
  background: #fff;
  z-index: 1000;
  height: 100vh;
  width: 66%;
  padding-top: 34px;
`;

export const NotesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px 20px 10px;
`;

export const CloseNotesPanelButton = styled.img`
  background: #e0ebf2;
  padding: 6px;
  border-radius: 50%;
`;

export const NotesPanelCardContainer = styled.div`
  background: #fff;
  box-shadow: 0px 1px 3px 0px #00000040;
  width: 282px;
  padding: 17px 20px;
  color: #000;
  font-size: 11px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

export const NotesPanelCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const NotesPanelCardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NotesPanelCardName = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Open Sans;
  font-weight: 600;
`;

export const NotesPanelCardDate = styled.div`
  display: flex;
  flex-direction: column;
  color: grey;
`;

export const NotesCardStatus = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  background: #FBEEC1;
  padding: 2px 5px;
`;

export const NotesPanelCardText = styled.div`
  width: 100%;
`;

export const NotesPanelCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const PanelCardsSearchInputContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  overflow: hidden;
  padding: 3px 20px;
  background: #F8EFE7;
  margin-right: 10px;
`;

export const PanelCardsSearchInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  background: #F8EFE7;
`;

export const CalendarSearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  overflow: hidden;
  padding: 3px 20px;
  background: #fff;
  margin-right: 10px;
  margin-left: auto;
  min-width: 290px;
`;

export const CalendarSearchInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  background: #fff;
`;

export const AddElementButton = styled.div`
  cursor: pointer;
  font-size: 15px;
  color: rgba(101, 157, 189, 1);
  padding-left: 10px;
`;

export const ImgContainer = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: end;
  justify-content: center;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;